export const init_Special = {
    "actived": false,
    "affiliateId": "",
    "adult": 0,
    "infant": 0,
    "kid": 0,
    "packageId": "",
    "priceType": "percent",
    "userType": "seller",
}